export default "__VITE_ASSET__DK81bWfL__"